// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__1kJtb","active":"NavigationItem_active__jZsYi"};